import { Typography } from "@mui/material";
import { StyledComponentProps } from "@mui/styles";
import { FeedClassKey } from "assets/jss/common-styles";
import { PublicationActionType } from "models/ApiEnums";
import { FeedItemDto } from "models/ApiModels";
import * as React from "react";
import { Trans, useTranslation } from "react-i18next";
import Session from "services/Session";

/////////////////////////////////////////////////////////////////////////////////////

interface IProps {
    data: FeedItemDto;
    fullView: boolean;
}

type Props = IProps & StyledComponentProps<FeedClassKey>;

/////////////////////////////////////////////////////////////////////////////////////

const FooterLine: React.FC<Props> = (props) => {

    const { t } = useTranslation();
    const { data: { action }, classes } = props;

    if (action && action.actionType == PublicationActionType.ApproveSuggestion && action.requester.id == Session.user.id) {

        return (
            <div className={classes.footerContainer}>
                <Typography variant="caption">
                    <Trans
                        i18nKey="Common.Feed.Literals.FooterSuggestionText"
                        values={{ requestedOn: action.requestedOn }}
                        components={{ b: <strong /> }}
                    />
                </Typography>
            </div>
        );

    }

    return null;
};

export default FooterLine;
